const resolveJSON = (response) => {
  if (!response.ok) {
    throw Error(response.statusText)
  }
  return response.json()
}

const toUrlEncoded = obj => Object.keys(obj).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(obj[k])).join('&')

export { resolveJSON, toUrlEncoded }
